import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
    activeUrl: '/',
    activeTitle: 'Preloading...',
    activeComponent: 'Preloader',
    previousUrl: null,
    previousTitle: null,
    preLoadingComponent: null,
    animatingInComponent: null,
    animatingOutComponent: null,
    animatingOutStagedComponent: null,
    navTheme: 'grey'
}

const navSlice = createSlice({
    name: 'nav',
    initialState: INITIAL_STATE,
    reducers: {
        saveNavTheme(state, action) {
            state.navTheme = action.payload
        },
        saveNavClick(state, action) {
            state.previousUrl = state.activeUrl
            state.previousTitle = state.activeTitle
            state.animatingOutStagedComponent = state.activeComponent
            state.activeUrl = action.payload.url
            state.activeTitle = action.payload.title
            state.activeComponent = action.payload.activeComponent
            state.preLoadingComponent = action.payload.preLoadingComponent
            state.animatingInComponent = action.payload.animatingInComponent
        },
        completePreloading(state) {
            state.animatingInComponent = state.preLoadingComponent
            state.preLoadingComponent = null
            state.animatingOutComponent = state.animatingOutStagedComponent
            state.animatingOutStagedComponent = null
        },
        completeAnimatingIn(state) {
            state.activeComponent = state.animatingInComponent
            state.animatingInComponent = null
        },
        completeAnimatingOut(state) {
            state.animatingOutComponent = null
        }
    }
})
export const { saveNavTheme, saveNavClick, completePreloading, completeAnimatingIn, completeAnimatingOut } = navSlice.actions
export default navSlice.reducer
